import { FC } from 'react';

import Container from 'quarks/Container';
import Flex from 'quarks/Flex';
import Heading from 'quarks/Heading';
import Text from 'quarks/Text';
import type { FlexProps } from 'quarks/interpolations/flex';

interface FilterSectionProps extends FlexProps {
  values: string[];
  selectedValues: string[];
  itemClick: (value: string) => void;
  label: string;
}

const headingWrapCSS = `
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const FilterHeading = ({ label }: { label: string }) => (
  <Container width="100%" height="fit-content" borderBottom="1px solid #D9D9D9">
    <Heading
      as="h4"
      textStyle="h6"
      data-cy="title"
      textColor="gray-900"
      css={headingWrapCSS}
      fontWeight="medium"
      paddingBottom={4}
    >
      {label}
    </Heading>
  </Container>
);

const FilterSection: FC<FilterSectionProps> = ({ values, selectedValues, itemClick, label, ...props }) => (
  <Flex {...props}>
    <FilterHeading label={label} />
    <Flex
      flexDirection="column"
      gap="20px"
      css={`
        @media (hover: hover) {
          .text-link:hover {
            color: #4bb699;
          }
        }

        .active {
          font-weight: bold;
          color: #282828;
        }
      `}
    >
      {values.map((value: string) => (
        <Text
          key={`topic_${value}`}
          onClick={() => itemClick(value)}
          textColor="gray-900"
          cursor="pointer"
          fontSize="h6"
          width="fit-content"
          className={`text-link ${selectedValues.includes(value) ? 'active' : ''}`}
        >
          {value}
        </Text>
      ))}
    </Flex>
  </Flex>
);

export default FilterSection;
